/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import moveEntityTemplate from '../admin/entity/move-entity.tpl.html';
import copyEntityTemplate from '../admin/entity/copy-entity.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import MoveEntityController from '../admin/entity/move-entity.controller';
import CopyEntityController from '../admin/entity/copy-entity.controller';

export default angular.module('agrolog.api.device', [])
    .factory('agDeviceService', DeviceService)
    .name;

/*@ngInject*/
function DeviceService($q, $http, $mdDialog, $document, $translate, $filter, types, agUtils, agTypes, agUserService, userService,
                       entityService, attributeService, deviceService, assetService, entityRelationService) {

    var allRelayAttributesKeys = [];
    var allRelayRelationAttributesKeys = [];
    var allTemperatureSensorLinesServerAttributesKeys = [];
    var allTemperatureSensorLinesClientAttributesKeys = [];
    var allLevelIndicatorServerAttributesKeys = [];
    var allWeatherStationAttributesKeys = [];
    var allHeadSpaceSensorAttributesKeys = [];

    var attributeKeysMap = {};
    attributeKeysMap[agTypes.deviceType.relay] = allRelayAttributesKeys;
    attributeKeysMap[agTypes.deviceType.temperatureSensorLines] = allTemperatureSensorLinesServerAttributesKeys;
    attributeKeysMap[agTypes.deviceType.moistureSensorLines] = allTemperatureSensorLinesServerAttributesKeys;
    attributeKeysMap[agTypes.deviceType.co2SensorLines] = allTemperatureSensorLinesServerAttributesKeys;
    attributeKeysMap[agTypes.deviceType.levelIndicator] = allLevelIndicatorServerAttributesKeys;
    attributeKeysMap[agTypes.deviceType.weatherStation] = allWeatherStationAttributesKeys;
    attributeKeysMap[agTypes.deviceType.headSpaceSensor] = allHeadSpaceSensorAttributesKeys;
    attributeKeysMap[agTypes.deviceType.gateway] = [];
    attributeKeysMap[agTypes.deviceType.sms] = [];
    attributeKeysMap[agTypes.deviceType.generic] = [];
    attributeKeysMap[agTypes.deviceType.relaySystem] = [];
    attributeKeysMap[agTypes.deviceType.default] = [];

    for (var attrId in agTypes.attributes.relay) {
        var attr = agTypes.attributes.relay[attrId];
        allRelayAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.relayRelation) {
        attr = agTypes.attributes.relayRelation[attrId];
        allRelayRelationAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.temperatureSensorLinesServer) {
        attr = agTypes.attributes.temperatureSensorLinesServer[attrId];
        allTemperatureSensorLinesServerAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.temperatureSensorLinesClient) {
        attr = agTypes.attributes.temperatureSensorLinesClient[attrId];
        allTemperatureSensorLinesClientAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.levelIndicatorServer) {
        attr = agTypes.attributes.levelIndicatorServer[attrId];
        allLevelIndicatorServerAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.weatherStationDevice) {
        attr = agTypes.attributes.weatherStationDevice[attrId];
        allWeatherStationAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.headSpaceSensor) {
        attr = agTypes.attributes.headSpaceSensor[attrId];
        allHeadSpaceSensorAttributesKeys.push(attr);
    }


    var service = {
        getAllDevices: getAllDevices,
        getAllSubsystems: getAllSubsystems,
        saveDevice: saveDevice,
        saveSubsysConfig: saveSubsysConfig,
        loadSubsysConfig: loadSubsysConfig,
        getParentGateway: getParentGateway,
        sendGatewayRpcCommand: sendGatewayRpcCommand,
        processGatewayRpcResponse: processGatewayRpcResponse,
        getDevice: getDevice,
        saveRelay: saveRelay,
        saveSensorLines: saveSensorLines,
        saveWeatherStation: saveWeatherStation,
        copySiloDevice: copySiloDevice,
        copyDeviceDialog: copyDeviceDialog,
        moveDeviceDialog: moveDeviceDialog,
        getSensorLines: getSensorLines,
        getWeatherStation: getWeatherStation,
        getRelay: getRelay,
        deleteDevice: deleteDevice,
        deleteRelayRelation: deleteRelayRelation,
        deleteModbusRelation: deleteModbusRelation,
        deleteSMSRelation: deleteSMSRelation,
        findParentSilo: findParentSilo,
        findParentAeration: findParentAeration,
        findParentWeatherStation: findParentWeatherStation,
        getRelaySystemRelaysList: getRelaySystemRelaysList,
        getConnectedSubsystemsList: getConnectedSubsystemsList,
        getModbusDevicesList: getModbusDevicesList,
        getSMSDevicesList: getSMSDevicesList,
        addConnectedSubsystem: addConnectedSubsystem,
        deleteRelation: deleteRelation,
        addRelaySystemRelay: addRelaySystemRelay,
        getDevicesByType: getDevicesByType,
        addModbusDevice: addModbusDevice,
        addSMSDevice: addSMSDevice,
        claimDevice: claimDevice
    };

    return service;


    function getAllDevices() {
        var deferred = $q.defer();
        entityService.getEntitiesByNameFilter(types.entityType.device, '', -1).then(
            (devices) => {
                if (devices) {
                    devices.forEach((device) => {
                        device.typeName = $translate.instant(agTypes.deviceTypeTranslatePrefix+'.'+device.type);
                    });
                    deferred.resolve(devices);
                } else {
                    deferred.reject();
                }
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAllSubsystems() {
        var deferred = $q.defer();
        var authority = userService.getAuthority();
        var getDevicesTasks = [];
        if (authority == 'TENANT_ADMIN') {
            //getDevicesTasks.push(deviceService.getTenantDevices({limit: 100}, null, null, agTypes.deviceType.gateway));
            getDevicesTasks.push(deviceService.getTenantDevices({limit: 100}, null, null, agTypes.deviceType.sms));
            $q.all(getDevicesTasks).then(
                (devices) => {
                    var result = [];
                    for (var i = 0; i < devices.length; i++) {
                        result = result.concat(devices[i].data);
                    }
                    result.forEach((device) => {
                        device.typeName = $translate.instant(agTypes.deviceTypeTranslatePrefix+'.'+device.type);
                    });
                    deferred.resolve(result);
                },
                () => {
                    deferred.reject();
                }
            );
        } else if (authority == 'CUSTOMER_USER') {
            agUserService.getAgrologCustomer().then(
                (agCustomer) => {
                    var agCustomerId = agCustomer.id;
                    //getDevicesTasks.push(deviceService.getCustomerDevices(agCustomerId.id, {limit: 100}, null, null, agTypes.deviceType.gateway));
                    getDevicesTasks.push(deviceService.getCustomerDevices(agCustomerId.id, {limit: 100}, null, null, agTypes.deviceType.sms));
                    $q.all(getDevicesTasks).then(
                        (devices) => {
                            var result = [];
                            for (var i = 0; i < devices.length; i++) {
                                result = result.concat(devices[i].data);
                            }
                            result.forEach((device) => {
                                device.typeName = $translate.instant(agTypes.deviceTypeTranslatePrefix+'.'+device.type);
                            });
                            deferred.resolve(result);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                },
                () => {
                    deferred.reject();
                }
            );
        }

        return deferred.promise;
    }

    function saveDevice(device, onRpcError) {
        var deferred = $q.defer();
        var assign = !device.id || !device.id.id;
        var createNewSubsysConfig = false;
        if (device.type === agTypes.deviceType.gateway || device.type === agTypes.deviceType.sms || device.type === agTypes.deviceType.generic ||
            device.type === agTypes.deviceType.relaySystem || device.type === agTypes.deviceType.modbus) {
            if (!device.additionalInfo) {
                device.additionalInfo = {};
            }
            device.additionalInfo.gateway = true;
            createNewSubsysConfig = !device.id;
        }
        deviceService.saveDevice(device).then(
            (savedDevice) => {
                device.id = savedDevice.id;
                var promise;
                if (createNewSubsysConfig) {
                    promise = createSubsysConfig(device, device.gatewayId, onRpcError);
                } else {
                    promise = $q.when(null);
                }
                promise.then(
                    (subsysConfig) => {
                        if (assign) {
                            agUserService.assignDeviceToCustomer(savedDevice).then(
                                () => {
                                    updateDeviceParameters(device, createNewSubsysConfig, subsysConfig, deferred);
                                },
                                () => {
                                    deferred.reject();
                                }
                            );
                        } else {
                            updateDeviceParameters(device, createNewSubsysConfig, subsysConfig, deferred);
                        }
                    },
                    () => {
                        deleteDevice(device.id).then(() => {
                            delete device.id;
                            deferred.reject();
                        });
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function updateDeviceParameters(device, createSubsysConfig, subsysConfig, deferred) {
        saveDeviceAttributes(device).then(
            (device) => {
                var promise;
                if (device.type === agTypes.deviceType.sms || device.type === agTypes.deviceType.generic || device.type === agTypes.deviceType.relaySystem || device.type === agTypes.deviceType.modbus) {
                    promise = saveParentGateway(device);
                } else {
                    promise = $q.when();
                }
                promise.then(
                    () => {
                        if (createSubsysConfig) {
                            saveSubsysConfig(device, subsysConfig).then(
                                () => {
                                    deferred.resolve(device);
                                },
                                () => {
                                    deferred.reject();
                                }
                            );
                        } else {
                            deferred.resolve(device);
                        }

                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
    }

    function saveParentGateway(device) {
        var deferred = $q.defer();
        if (device.gatewayId) {
            getParentGateway(device.id.id).then(
                (gateway) => {
                    if (gateway && angular.equals(gateway.id.id, device.gatewayId)) {
                        deferred.resolve();
                    } else {
                        var promise;
                        if (gateway) {
                            promise = entityRelationService.deleteRelation(gateway.id.id, gateway.id.entityType,
                                types.entityRelationType.contains, device.id.id, device.id.entityType)
                        } else {
                            promise = $q.when();
                        }
                        promise.then(
                            () => {
                                var relation = {
                                    from: {id: device.gatewayId, entityType: types.entityType.device},
                                    to: device.id,
                                    type: types.entityRelationType.contains
                                };
                                entityRelationService.saveRelation(relation).then(
                                    () => {
                                        deferred.resolve();
                                    },
                                    () => {
                                        deferred.reject();
                                    }
                                )
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    }
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            deferred.reject();
        }
        return deferred.promise;
    }

    function getParentGateway(deviceId) {
        var deferred = $q.defer();
        var searchQuery = {
            parameters: {
                rootId: deviceId,
                rootType: types.entityType.device,
                direction: types.entitySearchDirection.to,
                maxLevel: 1
            },
            relationType: types.entityRelationType.contains,
            deviceTypes: [agTypes.deviceType.gateway]
        };
        deviceService.findByQuery(searchQuery, true, {ignoreLoading: true}).then(
            (devices) => {
                if (devices && devices.length) {
                    deferred.resolve(devices[0]);
                } else {
                    deferred.resolve(null);
                }
            },
            () => {
                deferred.reject();
            }
        )
        return deferred.promise;
    }

    function createSubsysConfig(device) {
        var deferred = $q.defer();
        agUtils.createDefaultSubsysConfig(device).then(
            (subsysConfig) => {
                deferred.resolve(subsysConfig);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function sendGatewayRpcCommand(method, params, gatewayId, timeout, onRpcError, oneWay) {
        var requestBody = {
            method: method,
            params: params,
            timeout: timeout || 500
        };
        var deferred = $q.defer();
        if(!oneWay) {
            deviceService.sendTwoWayRpcCommand(gatewayId, requestBody).then(
                (responseBody) => {
                    deferred.resolve(responseBody);
                },
                (rejection) => {
                    handleRpcError(rejection, onRpcError);
                    deferred.reject(rejection);
                }
            );
        } else {
            deviceService.sendOneWayRpcCommand(gatewayId, requestBody).then(
                () => {
                    deferred.resolve();
                },
                (rejection) => {
                    handleRpcError(rejection, onRpcError);
                    deferred.reject(rejection);
                }
            );
        }
        return deferred.promise;
    }

    function processGatewayRpcResponse(responseBody, onRpcError) {
        var deferred = $q.defer();
        if (responseBody.status) {
            if (responseBody.status == "ok") {
                deferred.resolve(responseBody.result);
            } else if (responseBody.status == "error") {
                if (onRpcError) {
                    onRpcError(responseBody.error);
                }
                deferred.reject();
            } else {
                if (onRpcError) {
                    onRpcError(`Unknown response status: ${responseBody.status}`);
                }
                deferred.reject();
            }
        } else {
            if (onRpcError) {
                onRpcError(`Unrecognized response`);
            }
            deferred.reject();
        }
        return deferred.promise;
    }

    function handleRpcError(rejection, onRpcError) {
        if (rejection.status === 408) {
            if (onRpcError) {
                onRpcError($translate.instant('ag.subsys.subsys-not-responding'));
            }
        } else {
            var errorText = 'Error : ' + rejection.status + ' - ' + rejection.statusText;
            if (rejection.data && rejection.data.length > 0) {
                errorText += '</br>';
                errorText += rejection.data;
            }
            if (onRpcError) {
                onRpcError(errorText);
            }
        }
    }

    function saveDeviceAttributes(device) {
        let deferred = $q.defer();
        let serverAttributeKeys = attributeKeysMap[device.type];
        if (serverAttributeKeys && serverAttributeKeys.length) {
            let serverAttributes = [];
            for (let i = 0; i < serverAttributeKeys.length; i++) {
                let serverKey = serverAttributeKeys[i];
                serverAttributes.push({key: serverKey, value: device[serverKey]});
            }
            attributeService.saveEntityAttributes(device.id.entityType, device.id.id, types.attributesScope.server.value, serverAttributes).then(
                () => {
                    let clientAttributesKeys = allTemperatureSensorLinesClientAttributesKeys;
                    let clientAttributes = {};
                    for (let i = 0; i < clientAttributesKeys.length; i++) {
                        let clientKey = clientAttributesKeys[i];
                        if (device[clientKey]) {
                            clientAttributes[clientKey] = device[clientKey];
                        }
                    }
                    if (Object.keys(clientAttributes).length !== 0) {
                        saveDeviceClientAttributes(device.id.id, clientAttributes).then(
                            () => {
                                deferred.resolve(device);
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    } else {
                        deferred.resolve(device);
                    }
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            deferred.resolve(device);
        }
        return deferred.promise;
    }

    function saveSubsysConfig(device, subsysConfig) {
        var deferred = $q.defer();
        var promise;
        if (!subsysConfig) {
            promise = agUtils.createDefaultSubsysConfig(device);
        } else {
            promise = $q.when(subsysConfig);
        }
        promise.then((subsysConfig) => {
            var attributes = [];
            attributes.push({key: 'subsysConfig', value: subsysConfig});
            attributeService.saveEntityAttributes(device.id.entityType, device.id.id, types.attributesScope.server.value, attributes)
                .then(
                    () => {
                        deferred.resolve(subsysConfig);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            });
        return deferred.promise;
    }

    function loadSubsysConfig(deviceId) {
        var deferred = $q.defer();
        attributeService.getEntityAttributesValues(types.entityType.device, deviceId,
            types.attributesScope.server.value, 'subsysConfig',
            {ignoreLoading: true}).then(
            (attributes) => {
                if (attributes && attributes.length) {
                    var subsysConfig = angular.fromJson(attributes[0].value);
                    deferred.resolve(subsysConfig);
                } else {
                    deferred.reject();
                }
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getRelaySystemRelaysList(deviceId) {
        return entityService.getRelatedEntities(deviceId, types.entityType.device,
            [agTypes.deviceType.relay], 1, allRelayAttributesKeys,
            agTypes.deviceTypeTranslatePrefix, agTypes.relationType.relay);
    }

    function addRelaySystemRelay(relaySysId, relayId) {
        var relation = {
            from: relaySysId,
            type: agTypes.relationType.relay,
            to: relayId
        };
        return entityRelationService.saveRelation(relation);
    }

    function addModbusDevice(modbusId, modbusDeviceId) {
        var relation = {
            from: modbusId,
            type: agTypes.relationType.modbus,
            to: modbusDeviceId
        };
        return entityRelationService.saveRelation(relation);
    }


    function addSMSDevice (smsId, smsDeviceId) {
        var relation = {
            from: smsId,
            type: agTypes.relationType.sms,
            to: smsDeviceId
        };
        return entityRelationService.saveRelation(relation);
    }

    function getModbusDevicesList(deviceId) {
        return entityService.getRelatedEntities(deviceId, types.entityType.device,
            [agTypes.deviceType.levelIndicator, agTypes.deviceType.weatherStation, agTypes.deviceType.headSpaceSensor, agTypes.deviceType.headSpaceSensor2000], 1, [agTypes.attributes.weatherStationDevice.deviceType, agTypes.attributes.weatherStationDevice.address],
            agTypes.deviceTypeTranslatePrefix, agTypes.relationType.modbus);
    }

    function getSMSDevicesList(deviceId) {
        return entityService.getRelatedEntities(deviceId, types.entityType.device,
            [agTypes.deviceType.levelIndicator, agTypes.deviceType.weatherStation, agTypes.deviceType.headSpaceSensor, agTypes.deviceType.headSpaceSensor2000], 1, [agTypes.attributes.weatherStationDevice.deviceType, agTypes.attributes.weatherStationDevice.address],
            agTypes.deviceTypeTranslatePrefix, agTypes.relationType.sms);
    }

    function getConnectedSubsystemsList(deviceId) {
        return entityService.getRelatedEntities(deviceId, types.entityType.device,
            [agTypes.deviceType.sms, agTypes.deviceType.relaySystem, agTypes.deviceType.modbus], 1, [],
            agTypes.deviceTypeTranslatePrefix, types.entityRelationType.contains);
    }

    function addConnectedSubsystem(gatewayId, smsId) {
        var relation = {
            from: gatewayId,
            type: types.entityRelationType.contains,
            to: smsId
        };
        return entityRelationService.saveRelation(relation);
    }

    function deleteRelation(deviceId, parentId) {
        var deferred = $q.defer();
        entityRelationService.deleteRelation(parentId.id, parentId.entityType,
            types.entityRelationType.contains,
            deviceId.id, deviceId.entityType).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getDevice(deviceId) {
        var deferred = $q.defer();
        deviceService.getDevice(deviceId.id).then(
            (device) => {
                device.typeName = $translate.instant(agTypes.deviceTypeTranslatePrefix+'.'+device.type);
                fetchDeviceAttributes(device).then(
                    (device) => {
                        if (device.type == agTypes.deviceType.sms || device.type == agTypes.deviceType.generic || device.type == agTypes.deviceType.relaySystem || device.type == agTypes.deviceType.modbus) {
                            getParentGateway(device.id.id).then(
                                (gateway) => {
                                    if (gateway) {
                                        device.gatewayId = gateway.id.id;
                                    }
                                    deferred.resolve(device);
                                },
                                () => {
                                    deferred.reject();
                                }
                            );
                        } else {
                            deferred.resolve(device);
                        }
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function fetchDeviceAttributes(device) {
        var deferred = $q.defer();
        var serverAttributeKeys = attributeKeysMap[device.type];
        if (serverAttributeKeys && serverAttributeKeys.length) {
            attributeService.getEntityAttributesValues(device.id.entityType, device.id.id,
                types.attributesScope.server.value, serverAttributeKeys.join(','),
                {ignoreLoading: true}).then(
                (serverAttributes) => {
                    if (serverAttributes && serverAttributes.length > 0) {
                        for (var i = 0; i < serverAttributeKeys.length; i++) {
                            var serverKey = serverAttributeKeys[i];
                            device[serverKey] = getAttributeValue(serverAttributes, serverKey);
                        }
                    }
                    if (device.type === agTypes.deviceType.temperatureSensorLines || device.type === agTypes.deviceType.moistureSensorLines || device.type === agTypes.deviceType.co2SensorLines) {
                        var clientAttributesKeys = allTemperatureSensorLinesClientAttributesKeys;
                        attributeService.getEntityAttributesValues(device.id.entityType, device.id.id,
                            types.attributesScope.client.value, clientAttributesKeys.join(','),
                            {ignoreLoading: true}).then(
                            (clientAttributes) => {
                                if (clientAttributes && clientAttributes.length > 0) {
                                    for (var j = 0; j < clientAttributesKeys.length; j++) {
                                        var clientKey = clientAttributesKeys[j];
                                        device[clientKey] = getAttributeValue(clientAttributes, clientKey);
                                    }
                                }
                                deferred.resolve(device);
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    } else {
                        deferred.resolve(device);
                    }
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            deferred.resolve(device);
        }
        return deferred.promise;
    }

    function getAttributeValue(attributes, key) {
        var foundAttributes = $filter('filter')(attributes, {key: key}, true);
        if (foundAttributes.length > 0) {
            return foundAttributes[0].value;
        } else {
            return null;
        }
    }

    function saveRelay(relay) {
        var deferred = $q.defer();
        var relayTasks = [];
        for (var i = 0; i < relay.assignedSystemsInfo.length; i++) {
            var relation = {
                from: relay.assignedSystemsInfo[i].assetId,
                type: agTypes.relationType.relay,
                additionalInfo: {
                    channelIds: relay.assignedSystemsInfo[i].channelIds
                }
            };
            relayTasks.push(entityService.saveRelatedEntity(relay, relay.assignedSystemsInfo[i].assetId, [], relation));
        }
        var assign = !relay.id || !relay.id.id;
        $q.all(relayTasks).then(
            (relays) => {
                if (assign) {
                    agUserService.assignDeviceToCustomer(relay).then(
                        () => {
                            deferred.resolve(relay);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(relays[0]);
                }
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveSensorLines(sensorLines, parentEntityId) {
        var deferred = $q.defer();
        var assign = !sensorLines.id || !sensorLines.id.id;
        entityService.saveRelatedEntity(sensorLines, parentEntityId, allTemperatureSensorLinesServerAttributesKeys).then(
            function success(sensorLines) {
                if (assign) {
                    agUserService.assignDeviceToCustomer(sensorLines).then(
                        () => {
                            deferred.resolve(sensorLines);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(sensorLines);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveWeatherStation(weatherStation, parentEntityId) {
        var deferred = $q.defer();
        var assign = !weatherStation.id || !weatherStation.id.id;
        entityService.saveRelatedEntity(weatherStation, parentEntityId, allWeatherStationAttributesKeys).then(
            function success(weatherStation) {
                if (assign) {
                    agUserService.assignDeviceToCustomer(weatherStation).then(
                        () => {
                            deferred.resolve(weatherStation);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(weatherStation);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function copySiloDevice(device, targetEntityId) {
        var deferred = $q.defer();
        let keys = [];
        if (device.type === agTypes.deviceType.temperatureSensorLines || device.type === agTypes.deviceType.moistureSensorLines || device.type === agTypes.deviceType.co2SensorLines) {
            keys = allTemperatureSensorLinesServerAttributesKeys;
        } else if (device.type === agTypes.deviceType.levelIndicator) {
            keys.push(agTypes.attributes.levelIndicatorServer.measurePoints);
        }
        entityService.copyEntity(device, targetEntityId, keys).then(
            function success(device) {
                agUserService.assignDeviceToCustomer(device).then(
                    () => {
                        deferred.resolve(device);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function copyDeviceDialog($event, device) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }
        var placeholderText = 'ag.device.select-copy-target-text';
        var notFoundText = 'ag.device.copy-target-not-found-text';
        var requiredText = 'ag.device.copy-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.silo];
        var newEntityNameText = 'ag.device.new-device-name';
        var newEntityNameRequiredText = 'ag.device.new-device-name-required';

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: CopyEntityController,
                    controllerAs: 'vm',
                    templateUrl: copyEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        entity: angular.copy(device),
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes,
                        newEntityNameText: newEntityNameText,
                        newEntityNameRequiredText: newEntityNameRequiredText
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then((targetEntityId) => {
                    if (device.type === agTypes.deviceType.moistureSensorLines || device.type === agTypes.deviceType.co2SensorLines || device.type === agTypes.deviceType.levelIndicator || device.type === agTypes.deviceType.headSpaceSensor) {
                        let targetKey;
                        if (device.type === agTypes.deviceType.moistureSensorLines) {
                            targetKey = agTypes.attributes.silo.hasMoistureCables;
                        } else if (device.type === agTypes.deviceType.co2SensorLines) {
                            targetKey = agTypes.attributes.silo.hasCO2Cables;
                        } else if (device.type === agTypes.deviceType.levelIndicator) {
                            targetKey = agTypes.attributes.silo.hasLevelIndicator;
                        } else if (device.type === agTypes.deviceType.headSpaceSensor) {
                            targetKey = agTypes.attributes.silo.hasHeadSpaceSensor
                        }
                        attributeService.saveEntityAttributes(targetEntityId.entityType, targetEntityId.id,
                            types.attributesScope.server.value, [{key: targetKey, value: true}]).then(
                            () => {
                                deferred.resolve();
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    } else {
                        deferred.resolve();
                    }
                }, () => {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function moveDeviceDialog($event, device, parentEntityId) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }

        var placeholderText = 'ag.device.select-move-target-text';
        var notFoundText = 'ag.device.move-target-not-found-text';
        var requiredText = 'ag.device.move-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.silo];

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: MoveEntityController,
                    controllerAs: 'vm',
                    templateUrl: moveEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        parentEntityId: parentEntityId,
                        entity: device,
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then((targetEntityId) => {
                    if (device.type === agTypes.deviceType.moistureSensorLines || device.type === agTypes.deviceType.co2SensorLines || device.type === agTypes.deviceType.levelIndicator || device.type === agTypes.deviceType.headSpaceSensor) {
                        let targetKey;
                        if (device.type === agTypes.deviceType.moistureSensorLines) {
                            targetKey = agTypes.attributes.silo.hasMoistureCables;
                        } else if (device.type === agTypes.deviceType.co2SensorLines) {
                            targetKey = agTypes.attributes.silo.hasCO2Cables;
                        } else if (device.type === agTypes.deviceType.levelIndicator) {
                            targetKey = agTypes.attributes.silo.hasLevelIndicator;
                        } else if (device.type === agTypes.deviceType.headSpaceSensor) {
                            targetKey = agTypes.attributes.silo.hasHeadSpaceSensor
                        }
                        attributeService.saveEntityAttributes(targetEntityId.entityType, targetEntityId.id,
                            types.attributesScope.server.value, [{key: targetKey, value: true}]).then(
                            () => {
                                deferred.resolve();
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    } else {
                        deferred.resolve();
                    }
                }, () => {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function getSensorLines(deviceId) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(deviceId, allTemperatureSensorLinesServerAttributesKeys, agTypes.deviceTypeTranslatePrefix,
            allTemperatureSensorLinesClientAttributesKeys).then(
            function success(sensorLines) {
                deferred.resolve(sensorLines);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getWeatherStation(deviceId) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(deviceId, allWeatherStationAttributesKeys, agTypes.deviceTypeTranslatePrefix).then(
            function success(weatherStation) {
                deferred.resolve(weatherStation);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getRelay(deviceId) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(deviceId, allRelayAttributesKeys, agTypes.deviceTypeTranslatePrefix).then(
            function success(relay) {
                findRelayAssignedAerationSystemsInfo(relay.id.id).then(
                    function success(assignedSystems) {
                        relay.assignedSystemsInfo = [];
                        if (assignedSystems.length) {
                            for (var i = 0; i < assignedSystems.length; i++) {
                                if (assignedSystems[i].additionalInfo.channelIds && assignedSystems[i].additionalInfo.channelIds.length) {
                                    var systemInfoObj = {
                                        assetId: assignedSystems[i].from,
                                        assetName: assignedSystems[i].fromName,
                                        channelIds: assignedSystems[i].additionalInfo.channelIds
                                    };
                                    relay.assignedSystemsInfo.push(systemInfoObj);
                                }
                            }
                        }
                        deferred.resolve(relay);
                    },
                    function fail() {
                        deferred.reject();
                    }
                )
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteDevice(deviceId) {
        var deferred = $q.defer();
        entityService.deleteRelatedEntity(deviceId).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteRelayRelation(deviceId, parentId) {
        var deferred = $q.defer();
        entityRelationService.deleteRelation(parentId.id, parentId.entityType,
            agTypes.relationType.relay,
            deviceId.id, deviceId.entityType).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteModbusRelation(deviceId, parentId) {
        var deferred = $q.defer();
        entityRelationService.deleteRelation(parentId.id, parentId.entityType,
            agTypes.relationType.modbus,
            deviceId.id, deviceId.entityType).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteSMSRelation(deviceId, parentId) {
        var deferred = $q.defer();
        entityRelationService.deleteRelation(parentId.id, parentId.entityType,
            agTypes.relationType.sms,
            deviceId.id, deviceId.entityType).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function findParentSilo(deviceId) {
        return findParent(deviceId, [agTypes.assetType.silo]);
    }

    function findParentAeration(deviceId) {
        return findParent(deviceId, [agTypes.assetType.aeration], agTypes.relationType.relay);
    }

    function findParentWeatherStation(deviceId) {
        return findParent(deviceId, [agTypes.assetType.weatherStation]);
    }

    function findParent(deviceId, assetTypes, relationType) {
        var deferred = $q.defer();
        var searchQuery = {
            parameters: {
                rootId: deviceId,
                rootType: types.entityType.device,
                direction: types.entitySearchDirection.to,
                maxLevel: 1
            },
            relationType: relationType ? relationType : types.entityRelationType.contains,
            assetTypes: assetTypes
        };
        assetService.findByQuery(searchQuery, false, {ignoreLoading: true}).then(
            function success(silos) {
                if (silos && silos.length) {
                    deferred.resolve(silos[0]);
                } else {
                    deferred.resolve(null);
                }
            },
            function fail() {}
        );
        return deferred.promise;
    }

    function findRelayAssignedAerationSystemsInfo(relayId) {
        var deferred = $q.defer();
        var searchQuery = {
            parameters: {
                rootId: relayId,
                rootType: types.entityType.device,
                direction: types.entitySearchDirection.to,
                maxLevel: 1
            },
            filters: [{relationType: agTypes.relationType.relay, entityTypes: [types.entityType.asset]}]
        };
        entityRelationService.findInfoByQuery(searchQuery).then(
            (data) => {
                deferred.resolve(data);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getDevicesByType(type) {
        let deferred = $q.defer();
        let authority = userService.getAuthority();
        let getDevicesPromise;
        if (authority === 'TENANT_ADMIN') {
            getDevicesPromise = deviceService.getTenantDevices({limit: 1000}, null, null, type);
        } else if (authority === 'CUSTOMER_USER') {
            let customerDetails = userService.getCurrentUserDetails();
            getDevicesPromise = deviceService.getCustomerDevices(customerDetails.customerId.id, {limit: 1000}, null, null, type);
        }
        getDevicesPromise.then(
            (devices) => {
                deferred.resolve(devices.data);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveDeviceClientAttributes(deviceId, attributesJson) {
        let deferred = $q.defer();
        deviceService.getDeviceCredentials(deviceId).then(
            (credentials) => {
                let url = "/api/v1/" + credentials.credentialsId + "/attributes";
                $http.post(url, attributesJson).then(
                    () => {
                        deferred.resolve();
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function claimDevice(deviceName, deviceSecret, config) {
        let deferred = $q.defer();
        let url = "/api/customer/device/" + deviceName + "/claim";
        let obj = deviceSecret ? { secretKey: deviceSecret } : {};
        $http.post(url, obj, config).then(
            (payload) => {
                deferred.resolve(payload.data);
            },
            (error) => {
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }
}
